import React from "react";
import compose from "recompose/compose";
import { IconButton } from "theme/components/atoms/Button";
import MenuNavigationMobile from "./Menu/MenuNavigationMobile";
import SubNavigation from "./SubNavigation";
import { useIntl, defineMessages } from "react-intl";
import withIsFeatureActive from "web/core/UNSAFE_featureFlags/withIsFeatureActive";
import SearchNavigation from "theme/modules/Search/SearchBar/SearchNavigation";
import breakpoints from "theme/components/atoms/Breakpoints";

const messages = defineMessages({
  search: {
    id: "layouts.Header.Navigation.search",
    defaultMessage: "Search",
  },
  cart: {
    id: "layouts.Header.Navigation.cart",
    defaultMessage: "My Cart",
  },
  cartLength: {
    id: "layouts.Header.Navigation.cartLength",
    defaultMessage: "{quantity, plural, =1 {1 product} other {# products}}",
  },
  menu: {
    id: "layouts.Header.Navigation.menu",
    defaultMessage: "Menu",
  },
});

const HeaderLinksMobile = ({
  searchFeature,
  wishlistFeature,
  data,
  userData,
  selectMenu,
  renderSubNav,
  enterpriseMenuLink,
  storeView,
}) => {
  const intl = useIntl();
  const [isMobile, setIsMobile] = React.useState(true);

  React.useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < breakpoints.desktop);
    };

    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);

    return () => {
      window.removeEventListener("resize", checkIfMobile);
    };
  }, []);

  const handleMenuClick = (menuType) => {
    const headerSkeletonElement = document.querySelector(".header__skeleton");
    const headerElement = document.querySelector(".header");
    headerElement?.classList.add("mobile-open");
    headerSkeletonElement?.classList.add("mobile-open");

    selectMenu(menuType);
    if (menuType === "search") {
      setTimeout(() => {
        const searchInput = document.querySelector("#search");
        if (searchInput instanceof HTMLElement) {
          searchInput.focus();
        }
      }, 500);
    }
  };

  const handleCloseMenu = () => {
    const headerSkeletonElement = document.querySelector(".header__skeleton");
    const headerElement = document.querySelector(".header");
    headerElement?.classList.remove("mobile-open");
    headerSkeletonElement?.classList.remove("mobile-open");
    selectMenu(null);
  };

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        <li className="navigation__item">
          <IconButton
            icon="menu"
            title={intl.formatMessage(messages.menu)}
            onClick={() => handleMenuClick("menu")}
            size="none"
            type="button"
          />
          {renderSubNav("menu")(
            <SubNavigation onClose={handleCloseMenu}>
              <MenuNavigationMobile
                data={data}
                loading={userData?.loading ?? true}
                user={userData?.me}
                wishlistFeature={wishlistFeature}
                enterpriseMenuLink={enterpriseMenuLink}
                storeView={storeView}
                handleCloseMenu={handleCloseMenu}
              />
            </SubNavigation>
          )}
        </li>
        {isMobile && (
          <li className="navigation__item">
            <IconButton
              icon="search"
              title={intl.formatMessage(messages.search)}
              onClick={() => handleMenuClick("search")}
              size="none"
              iconType="svg"
              type="button"
              id="open-search"
            />
            {renderSubNav("search")(
              <SubNavigation onClose={handleCloseMenu}>
                <SearchNavigation />
              </SubNavigation>
            )}
          </li>
        )}
      </ul>
    </nav>
  );
};

export default compose(
  withIsFeatureActive("searchFeature", "search"),
  withIsFeatureActive("wishlistFeature", "wishlist")
)(HeaderLinksMobile);
